import { Component, OnInit, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { LoginService, Sistemas } from 'eddydata-lib';
import * as toastr from 'toastr';

@Component({
  selector: 'lib-atualizar-senha',
  templateUrl: './atualizar-senha.component.html',
  styleUrls: ['./atualizar-senha.component.css']
})
export class AtualizarSenhaComponent implements OnInit {
  public msgs: string;
  public email: string;
  public senha: string;
  public senha_nova: string;
  public senha_confirmacao: string;
  public sistema: Sistemas;
  public orgao: number;

  protected router: Router;
  protected unsubscribe: Subject<void> = new Subject();

  constructor(
    protected injector: Injector,
    private authService: LoginService
  ) {
    this.router = this.injector.get(Router);
  }

  ngOnInit() {
    if (history.state) {
      this.email = history.state.email;
      this.sistema = history.state.sistema;
      this.orgao = history.state.orgao;
    }
  }

  async atualizarSenha() {
    if (!this.senha || !this.senha_nova || !this.senha_confirmacao) {
      this.msgs = 'Preencha todos os campos.';
      return;
    }
    if (this.senha_nova !== this.senha_confirmacao) {
      this.msgs = 'A nova senha e a confirmação não coincidem.';
      return;
    }

    try {
      const resultado = await this.authService.atualizarSenha(
        this.email, this.orgao, this.senha, this.senha_nova, this.senha_confirmacao
      );

      if (resultado.status === 'success') {
        toastr.success('Senha atualizada com sucesso!');
        await this.authService.autenticar(this.email, this.senha_nova, this.sistema, null, this.orgao);
      } else {
        this.msgs = resultado?.error?.message ?? 'Erro ao atualizar senha.';
      }
    } catch (ex) {
      this.msgs = ex?.error?.message ?? 'Erro inesperado. Tente novamente.';
    }
  }

  voltar() {
    this.router.navigate([`/login`]);
  }

}
